import React, { useState, createContext, useMemo } from "react";
import RecruitmentDetail from "./components/templates/RecruitmentDetail";

export const recruitmentDetailContext = createContext();

export default function RecruitmentDetailPage() {
  const [reason, setReason] = useState(null);
  const [mailSubject, setMailSubject] = useState("");
  const [mailBody, setMailBody] = useState({ received: "", body: "" });
  const [projectId, setProjectId] = useState(null);
  const [projectStatus, setProjectStatus] = useState(null);

  // Contextに渡すオブジェクトをuseMemoでキャッシュし、不要な再レンダリングを防止
  const values = useMemo(
    () => ({
      reason,
      setReason,
      mailSubject,
      setMailSubject,
      mailBody,
      setMailBody,
      projectId,
      setProjectId,
      projectStatus,
      setProjectStatus,
    }),
    [reason, mailSubject, mailBody, projectId, projectStatus]
  );

  return (
    <recruitmentDetailContext.Provider value={values}>
      <RecruitmentDetail />
    </recruitmentDetailContext.Provider>
  );
}